import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarTipoServico from '../../components/modal/ModalCadastrarTipoServico';
import ModalEditarTipoServico from '../../components/modal/ModalEditarTipoServico';
import ModalExcluirTipoServico from '../../components/modal/ModalExcluirTipoServico';
import { ServicoContext } from '../../context/ServicoContext';
import Tabela from '../../components/Tabela';

function TipoServico() {
    const { Success, Error, openModal, setOpenModal, TiposServicoConsulta, ListaTipoServicoConsulta, loading, modalEditarTipoServico, setModalEditarTipoServico, setEdicaoTipoServico, setTipoServicoAtualKey, modalExcluirTipoServico, setModalExcluirTipoServico, InativarTipoServico, ListaFiltroTipoServico, totalRegistrosTipoServico, filtroTipoServico, totalRegistrosFiltroTipoServico } = useContext(ServicoContext)
    const { Permissao } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditTipoServico = (props) => {
        setModalEditarTipoServico(true)
        setTipoServicoAtualKey(props.key)
        setEdicaoTipoServico(props)
    }

    const DeletarTipoServico = (props) => {
        setTipoServicoAtualKey(props.key)
        setModalExcluirTipoServico(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroTipoServico(searchTerm, currentPage, pageSize);
        } else {
            ListaTipoServicoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroTipoServico : totalRegistrosTipoServico;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar tipo de serviços'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarTipoServico &&
                <ModalEditarTipoServico currentPage={currentPage} />
            }
            {modalExcluirTipoServico &&
                <ModalExcluirTipoServico currentPage={currentPage} />
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarTipoServico closeModal={setOpenModal} currentPage={currentPage} />
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar tipo de serviço</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Tipos de Serviços cadastrados</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroTipoServico : TiposServicoConsulta}
                            columns={[
                                { label: "Tipo de Serviço", field: "nome", width: "40%" },
                                { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                                {
                                    label: "Ativo",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div className="checkbox-wrapper" style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center" }}>
                                            <input type="checkbox" label=" Ativo" className="toggleBtn" onChange={() => InativarTipoServico(x.key, !x.ativo)} checked={x.ativo} />
                                        </div>
                                    ),
                                },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditTipoServico(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarTipoServico(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroTipoServico(term, 1, 10);
                                } else {
                                    ListaTipoServicoConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default TipoServico;